import { notification } from "antd";
import { useMemo, useState } from "react";
import ThirdPartyIntegration from "services/thirdPartyIntegrationService";

export const useQrBooking = () => {
  const [qrUrl, setQrUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const getQrCode = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 200));
    const result = await ThirdPartyIntegration.generateFlyerQRCode_DatLich({
      data: {
        partyRequiredData: {},
        partyActiveStatus: 1,
        partyEnableStatus: 1,
        integrationMetadata: {},
      },
    });
    setLoading(false);
    const data = result?.data?.partyRequiredData
      ? JSON.parse(result?.data?.partyRequiredData)
      : {};
    const imagesWithHttps = Object.fromEntries(
      Object.entries(data).map(([key, url]) => [key, `${url}`])
    );
    setQrUrl(imagesWithHttps);

    return imagesWithHttps;
  };

  const listImage = useMemo(() => {
    return [
      {
        title: "Mã QR đặt lịch",
        url: qrUrl?.bookingTableFlyerUrl2X,
        nameQr: "Mã QR đặt lịch",
        textDownload: "Tải QR đặt lịch",
        key: "bookingTableFlyerUrl2X",
      },
      {
        title: "Hướng dẫn",
        url: qrUrl?.bookingWallFlyerUrl2X,
        nameQr: "Hướng dẫn",
        textDownload: "Tải hướng dẫn",
        key: "bookingWallFlyerUrl2X",
      },
    ];
  }, [qrUrl]);

  const handleDownload = async (item) => {
    if (loading) return;
    const url = item.url;

    if (!url) {
      notification["error"]({
        message: "",
        description: "Không tải được ảnh",
      });
      return;
    }

    await fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = item.nameQr; // ép tải về file "bird.jpg"
        link.click();
        URL.revokeObjectURL(link.href); // giải phóng bộ nhớ
      })
      .catch((err) => console.error("Lỗi tải ảnh:", err));
  };

  return {
    qrUrl,
    loading,
    listImage,
    handleDownload,
    getQrCode,
  };
};
